// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1PgTm","options":"AnswerScale_options__3l4D4","selected":"AnswerScale_selected__QTmyy"};